// extracted by mini-css-extract-plugin
module.exports = {"all_component":"Donor_all_component__1_Zhi","donor":"Donor_donor__3R-fH","donor_info":"Donor_donor_info__22Pdc","donor_img":"Donor_donor_img__1hYQ8"};